import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { admin_profile, clear_state_on_logout, user_logout } from "../reduxData/auth/authAction";
import { Dropdown } from "react-bootstrap";
import DefaultImg from '../images/no_profile.png';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Button from "@mui/joy/Button";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import { Box } from "@mui/joy";
import NotificationHeader from '../reduxData/Notifications/NotificationHeader'
import LanguageSwitcher from './LanguageSwitcher'
import { requestFcmToken } from "../config/firebase";
import { MODULES } from "../config/modules";
import { useTranslation } from "react-i18next";

const { REACT_APP_IMAGE_URL } = process.env;

export const Header = () => {
  const { userDetails, accessToken, userPermissions } = useSelector((state) => state.auth);
  const [isCancel, setIsCancel] = React.useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // fetch admin profile data 
  useEffect(() => {
    const fetchData = async () => {
      try {
        await admin_profile(dispatch);
      } catch (error) {
        console.error("Error fetching auction categories:", error);
      }
    };
    fetchData();
  }, []);


  // handle logout functionality 
  const handleLogout = async () => {
    try {
      const token = await requestFcmToken();
      const topics = [
        `dispute_admin`
      ];
      let notification_flag;
      if (token == null) {
        notification_flag = false
      }
      else {
        notification_flag = true
      }
      const data = {
        deviceToken: token,
        topics: topics,
        notification_flag: notification_flag,
      };
      const result = await user_logout(data, dispatch);
      if (result) {
        clear_state_on_logout();
        setIsCancel(false);
        document.cookie = `isremember=; path=/`;
        window.location.replace("/");
      }
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
    }
  };

  const items = [
    {
      label: t("header.profile"),
      path: "/profile",
      module_name: MODULES.PROFILE,
      permission: "view",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M12 1.25a4.75 4.75 0 1 0 0 9.5a4.75 4.75 0 0 0 0-9.5M8.75 6a3.25 3.25 0 1 1 6.5 0a3.25 3.25 0 0 1-6.5 0M12 12.25c-2.313 0-4.445.526-6.024 1.414C4.42 14.54 3.25 15.866 3.25 17.5v.102c-.001 1.162-.002 2.62 1.277 3.662c.629.512 1.51.877 2.7 1.117c1.192.242 2.747.369 4.773.369s3.58-.127 4.774-.369c1.19-.24 2.07-.605 2.7-1.117c1.279-1.042 1.277-2.5 1.276-3.662V17.5c0-1.634-1.17-2.96-2.725-3.836c-1.58-.888-3.711-1.414-6.025-1.414M4.75 17.5c0-.851.622-1.775 1.961-2.528c1.316-.74 3.184-1.222 5.29-1.222c2.104 0 3.972.482 5.288 1.222c1.34.753 1.961 1.677 1.961 2.528c0 1.308-.04 2.044-.724 2.6c-.37.302-.99.597-2.05.811c-1.057.214-2.502.339-4.476.339s-3.42-.125-4.476-.339c-1.06-.214-1.68-.509-2.05-.81c-.684-.557-.724-1.293-.724-2.601"
            clip-rule="evenodd"
          />
        </svg>
      ),
    },
    {
      label: t("header.changePassword"),
      path: "/change-password",
      module_name: MODULES.PASSWORD,
      permission: "edit",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
        >
          <g fill="none" stroke="currentColor">
            <path
              stroke-width="1.5"
              d="M2 16c0-2.828 0-4.243.879-5.121C3.757 10 5.172 10 8 10h8c2.828 0 4.243 0 5.121.879C22 11.757 22 13.172 22 16s0 4.243-.879 5.121C20.243 22 18.828 22 16 22H8c-2.828 0-4.243 0-5.121-.879C2 20.243 2 18.828 2 16Z"
            />
            <path
              stroke-linecap="round"
              stroke-width="1.5"
              d="M6 10V8a6 6 0 1 1 12 0v2"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 16h.009m3.982 0H12m3.991 0H16"
            />
          </g>
        </svg>
      ),
    },
  ];

  const filterItems = items.filter(
    (route) => userPermissions?.[route.module_name]?.view === true
  );


  return (
    <div>
      <nav className="cream-box d-flex justify-content-end cont">
        {userPermissions?.notifications?.view && (<NotificationHeader />)}
        <LanguageSwitcher />
        <Dropdown
          id="dropdown-basic-button"
          className="drop-downlist"
          variant="light"
        >
          <Dropdown.Toggle id="dropdown-basic" style={{ width: '100%', padding: '0', background: 'none', border: 'none', color: '#000', display: 'flex', gap: '10px', alignItems: 'center' }}>
            {userDetails?.profile_pic ?
              <img src={`${REACT_APP_IMAGE_URL}${userDetails?.profile_pic}`} height={50} width={50} style={{ borderRadius: '50%' }} alt="" />
              :
              <img src={DefaultImg} alt="img not found" height={50} width={50} style={{ borderRadius: '50%' }} />
            }
            {userDetails?.user_name}

          </Dropdown.Toggle>
          <Dropdown.Menu>
            {filterItems.map((item, index) => (
              <div key={item.path}>
                <Dropdown.Item onClick={() => navigate(item.path)}>
                  <div className="dropdown-memulist d-flex align-items-center gap-2">
                    {item.icon}
                    {item.label}
                  </div>
                </Dropdown.Item>
              </div>
            ))}
            <Dropdown.Item onClick={() => { setIsCancel(true); }}><div className="dropdown-memulist align-items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M14.945 1.25c-1.367 0-2.47 0-3.337.117c-.9.12-1.658.38-2.26.981c-.524.525-.79 1.17-.929 1.928c-.135.737-.161 1.638-.167 2.72a.75.75 0 0 0 1.5.008c.006-1.093.034-1.868.142-2.457c.105-.566.272-.895.515-1.138c.277-.277.666-.457 1.4-.556c.755-.101 1.756-.103 3.191-.103h1c1.436 0 2.437.002 3.192.103c.734.099 1.122.28 1.4.556c.276.277.456.665.555 1.4c.102.754.103 1.756.103 3.191v8c0 1.435-.001 2.436-.103 3.192c-.099.734-.279 1.122-.556 1.399s-.665.457-1.399.556c-.755.101-1.756.103-3.192.103h-1c-1.435 0-2.436-.002-3.192-.103c-.733-.099-1.122-.28-1.399-.556c-.243-.244-.41-.572-.515-1.138c-.108-.589-.136-1.364-.142-2.457a.75.75 0 1 0-1.5.008c.006 1.082.032 1.983.167 2.72c.14.758.405 1.403.93 1.928c.601.602 1.36.86 2.26.982c.866.116 1.969.116 3.336.116h1.11c1.368 0 2.47 0 3.337-.116c.9-.122 1.658-.38 2.26-.982s.86-1.36.982-2.26c.116-.867.116-1.97.116-3.337v-8.11c0-1.367 0-2.47-.116-3.337c-.121-.9-.38-1.658-.982-2.26s-1.36-.86-2.26-.981c-.867-.117-1.97-.117-3.337-.117z"
                />
                <path
                  fill="currentColor"
                  d="M15 11.25a.75.75 0 0 1 0 1.5H4.027l1.961 1.68a.75.75 0 1 1-.976 1.14l-3.5-3a.75.75 0 0 1 0-1.14l3.5-3a.75.75 0 1 1 .976 1.14l-1.96 1.68z"
                />
              </svg> {t("header.logout")}</div>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </nav>

      <Modal open={isCancel} onClose={() => setIsCancel(false)}>
        <ModalDialog>
          <DialogTitle>{t("header.logoutConfirmTitle")}</DialogTitle>
          <DialogContent>
            {t("header.logoutConfirmMessage")}
          </DialogContent>
          <Box>
            <Button onClick={() => setIsCancel(false)}>{t("common.cancel")}</Button>
            <Button
              className="mx-2"
              color="danger"
              onClick={handleLogout}
            >
              {t("header.logout")}
            </Button>
          </Box>
        </ModalDialog>
      </Modal>
    </div>
  );
};
export default Header;
